import { Map, Record, List } from 'immutable';
import Address          from './address';
import { parameterize } from 'helpers/string';

import JobRecord from 'records/job_record'

const struct = {
  id:                  undefined,
  title:               undefined,
  campaignType:        undefined,
  locale:              undefined,
  remoteType:          undefined,
  createdAt:           undefined,
  updatedAt:           undefined,
  deletedAt:           undefined,
  origin:              new Map(),
  bearerToken:         undefined,
  address:             new Address(),
  facebookPixelId:     undefined,
  jobBanner:           undefined,
  settings:            {},
  companyJobBanner:    undefined,
  companyParameters:   {},
  company:             new Map(),
  countryShortCode:    undefined,
  prompts:             new List(),
  evaluationCriterias: new List(),
  talkscoreWeightDistribution: new Map(),
  jobLandingPageUrl:   undefined,
};

export default class CampaignRecord extends Record(struct, 'CampaignRecord') {
  cityLocation() {
    if (this.remoteType) return t(this.remoteType, { scope: 'eos.landing_page.text.remote_types', defaultValue: this.remoteType });

    const address = new Address(this.address);

    return address.cityLocation();
  }

  isLongForm() {
    return this.settings.landingPageType == 'single';
  }

  isOnboarding() {
    return this.campaignType === 'onboarding';
  }

  forceNewLandingPage() {
    return this.companyParameters.eosLandingPage === true;
  }

  hasFallbackBanner() {
    return this.forceNewLandingPage() && this.companyJobBanner !== undefined;
  }

  forceDefaultBanner() {
    return (
      this.forceNewLandingPage()
      && this.companyParameters.useBanner === true
      && this.companyJobBanner !== undefined
    );
  }

  companyLandingPageType() {
    if (!['single', 'multiple'].includes(this.companyParameters.landingPageType) || !this.forceNewLandingPage()) {
      return null;
    }

    return this.companyParameters.landingPageType;
  }

  jobType() {
    return t(parameterize(this.origin.jobType), { scope: 'eos.landing_page.text.job_type_options', defaultValue: t('eos.landing_page.text.job_type_options.default') });
  }

  salary() {
    const job = new JobRecord(this.origin);

    return job.salaryDetails()
  }

  brief() {
    return this.origin.brief;
  }
}
